import React from 'react'
import { Text } from "@chakra-ui/core";

const Title = props => <Text {...props} fontSize='2xl' fontWeight='bold' />

export default Title